import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: null as string | null, // Initialize from cookie usually
    user: null as any,
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
    hasPermission: (state) => (permission: string) => {
        return state.user?.permissions?.includes(permission) || state.user?.roles?.includes('Super Admin');
    },
    hasModule: (state) => (module: string) => {
        if (!module) return true; // No requirement
        const modules = state.user?.business?.settings?.modules || [];
        return modules.includes(module);
    },
    hasFeature: (state) => (feature: string) => {
        if (!feature) return true;
        const features = state.user?.business?.features || [];
        return features.includes(feature);
    },
    currentIndustry: (state) => state.user?.business?.industry_type || 'retail',
    isSuperAdmin: (state) => state.user?.roles?.includes('Super Admin'),
    isAdmin: (state) => state.user?.roles?.includes('Admin'),
    isManager: (state) => state.user?.roles?.includes('Manager'),
    isCashier: (state) => state.user?.roles?.includes('Cashier'),
  },
  actions: {
    setToken(token: string) {
      this.token = token;
      const cookie = useCookie('auth_token');
      cookie.value = token;
    },
    setUser(user: any) {
      this.user = user;
    },
    async login(credentials: any) {
        const { fetchData } = useApi();
        const { data, error } = await fetchData('/auth/login', {
            method: 'POST',
            body: credentials
        });
        if (error) throw error;
        this.setToken(data.token);
        this.setUser(data.user);
        return true;
    },
    async register(data: any) {
        const { fetchData } = useApi();
        const { data: res, error } = await fetchData('/auth/register', {
            method: 'POST',
            body: data
        });
        if (error) throw error;
        this.setToken(res.token);
        this.setUser(res.user);
        return true;
    },
    async logout() {
        const { fetchData } = useApi();
        try {
            await fetchData('/auth/logout', {
                method: 'POST'
            });
        } catch(e) {
            console.error(e);
        } finally {
            this.token = null;
            this.user = null;
            const cookie = useCookie('auth_token');
            cookie.value = null;
            navigateTo('/login');
        }
    },
    async fetchUser() {
        if (!this.token) return;
        const { fetchData } = useApi();
        try {
             const { data: user, error } = await fetchData('/auth/me');
             if (error) throw error;
             this.setUser(user);
        } catch (e) {
            this.logout(); // Invalid token
        }
    }
  },
});
